import React from 'react';
import withIcon from '../utilities/withIcon';

const IconToolbox = () => {
  return (
    <g>
      <path d="m15.1941 3.4219h-4.1436v-2.4483a.75.75 0 0 0 -.75-.75h-4.601a.75.75 0 0 0 -.75.75v2.4483h-4.1436a.75.75 0 0 0 -.75.75v10.8545a.75.75 0 0 0 .75.75h14.3882a.75.75 0 0 0 .75-.75v-10.8545a.75.75 0 0 0 -.75-.75zm-8.7446-1.6983h3.101v1.6983h-3.101zm7.9946 3.1982v3.3468h-12.8882v-3.3467zm-12.8882 9.3546v-4.5078h2.5527v.86a.75.75 0 0 0 1.5 0v-.86h4.7827v.86a.75.75 0 0 0 1.5 0v-.86h2.5527v4.5078z" />
    </g>
  );
};

export default withIcon(IconToolbox);
